import * as fetchApi from '@/config/fetchApi.js'
import * as constants from '@/config/constants.js'

export const authLogin = (headers) => fetchApi.get(constants.ENDPOINT_LOGIN, '', headers)
export const createUser = ({ name, login, password, active, profiles, pages, admin, has_pii_access }) =>
  fetchApi.post(constants.ENDPOINT_USERS, { name, login, password, active, profiles, pages, admin, has_pii_access })
export const getUsers = () => fetchApi.get(constants.ENDPOINT_USERS)
export const alterUser = ({ id, name, login, password, profiles, admin, pages, active, has_pii_access }) =>
  fetchApi.put(constants.ENDPOINT_USERS + '/' + id, { name, login, password, profiles, admin, pages, active, has_pii_access })
export const getClients = (headers) => fetchApi.get(constants.ENDPOINT_CLIENTS, '', headers)
export const getClientToken = (idClient, headers) => fetchApi.get(constants.ENDPOINT_CLIENTS + '/' + idClient, '', headers)
